import * as React from 'react';
import { useField } from 'informedv4';
import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { Required } from '../validation/Required';
import { TimePicker } from './TimePickerV4';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';

interface ConfigFieldTimePickerProps {
    id: string;
    field: string;
    name: string;
    itemId: ConfigurableDataItemIds;
    placeholder?: string;
}

export const ConfigFieldTimePicker = (props: ConfigFieldTimePickerProps): JSX.Element => {
    const {
        id,
        field,
        name,
        placeholder,
        itemId
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    const { fieldState, fieldApi } = useField({ name: field, validate: item.importanceId === DataItemImportance.Mandatory ? Required : undefined });

    const { setValue } = fieldApi;

    if (dataItemConfigurationCollection === null)
        throw 'Fields Configurations is not set';

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <TimePicker
                id={id}
                field={field}
                label={name}
                placeholderText={placeholder}
                required={item.importanceId === DataItemImportance.Mandatory}
                dateFormat="HH:mm"
            />
        </Condition>
    </>
}
